// Auto-init minicolors on .color elements and reset_default links
import jQuery from 'jquery'
import 'vendor/jquery.minicolors'

jQuery(function () {
  if (jQuery('.color').length) {
    jQuery('.color').minicolors()
  }
  jQuery('.reset_default').on('click', function () {
    var inp = jQuery(this).parent().find('input')
    inp.val(inp.data('default-value'))
  })
})
